import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const HeartIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 20.58C6.8 16.8 3.38 13.38 3.38 9.64C3.38 6.88 5.56 4.58 8.36 4.58C9.76 4.58 11.04 5.16 12 6.36C12.96 5.16 14.24 4.58 15.64 4.58C18.44 4.58 20.62 6.88 20.62 9.64C20.62 13.38 17.2 16.8 12 20.58ZM5.36 9.78C5.36 12.66 8.62 15.68 12 18.2C15.38 15.68 18.64 12.66 18.64 9.78C18.64 7.84 17.44 6.4 15.62 6.4C14.2 6.4 13.08 7.46 12 9.46C10.92 7.46 9.8 6.4 8.38 6.4C6.56 6.4 5.36 7.84 5.36 9.78Z" />
    </SvgIcon>
  );
});
